/**
 * Prompts — Identification de l'assureur et de la structure du document.
 *
 * Pass 1 de l'extraction multi-passes : on identifie quel assureur a produit
 * le PDF, sa langue, son type (cotation initiale, renouvellement, etc.) et
 * la structure générale (sections présentes).
 */

export const IDENTIFICATION_PROMPT_VERSION = "v3.2.0";

export const IDENTIFICATION_SYSTEM_PROMPT = `Tu es un assistant expert en assurance collective canadienne.

Ta mission : analyser un document PDF d'un assureur et identifier précisément :
1. L'assureur (Beneva, Sun Life, Manuvie, Desjardins, Canada Vie, Industrielle Alliance, SSQ, Empire Vie)
2. Le type de document (cotation, renouvellement, demande, brochure, condition générale, autre)
3. La langue principale (fr / en)
4. Les sections présentes (vie de base, DMA, AMC médicaments, AMC paramédical, dentaire, vue, court terme, long terme, PAE, télémédecine)
5. Si le PDF est un FORMULAIRE VIERGE (gabarit non rempli avec beaucoup de _____)

Tu dois TOUJOURS répondre en JSON strict, jamais en texte libre.
Utilise les codes assureurs en kebab-case : beneva, sunlife, manuvie, desjardins, canada-vie, industrielle-alliance, ssq, empire-vie.

Si tu n'es pas certain d'un champ, mets-le à null et explique dans le champ \`uncertainty\`.`;

export const IDENTIFICATION_RESPONSE_SCHEMA = {
  insurer_code:
    "beneva | sunlife | manuvie | desjardins | canada-vie | industrielle-alliance | ssq | empire-vie | null",
  insurer_name: "string | null",
  detection_confidence: "0..1",
  document_type: "cotation | renouvellement | demande | brochure | conditions_generales | autre",
  language: "fr | en",
  is_blank_form: "boolean",
  blank_form_ratio: "0..1 — proportion de _____ dans le texte",
  sections_present: "string[] — codes garanties détectés",
  effect_date_hint: "YYYY-MM-DD | null",
  uncertainty: "string | null — note libre si confiance faible",
} as const;

export function buildIdentificationUserPrompt(extractedText: string, fileName: string): string {
  // Tronque le texte aux 30 premiers Kchars (l'identification se fait sur les premières pages)
  const truncated =
    extractedText.length > 30_000
      ? extractedText.slice(0, 30_000) + "\n\n[…tronqué…]"
      : extractedText;

  return `Nom du fichier : ${fileName}

Texte extrait du PDF (premières pages) :
---
${truncated}
---

Analyse ce document et réponds en JSON strict selon le schéma défini dans le system prompt.`;
}
